import React from 'react';
import { Icon } from '../../components/Icon/index';
import getComponentClassNames from '../../utils/className/getComponentClassNames';

const classNames = getComponentClassNames(
  ['Listing', { modifiers: 'vertical' }],
  ['image', 'noImage', 'body', 'title', 'price', 'imageOverlayLabel', 'location'],
);

type TVerticalListingProps = {
  title: string;
  price: string;
  imageSrc?: string;
  imageLoading?: 'lazy' | 'eager' | undefined;
  decoding?: 'sync' | 'async' | 'auto' | undefined;
  currency?: string;
  imageOverlayLabel?: string;
  location?: string;
  className?: string;
  alt?: string;
  onError?: () => void;
};

const VerticalListing = ({
  title,
  price,
  imageSrc,
  imageLoading,
  decoding,
  currency = '',
  imageOverlayLabel,
  location,
  alt,
  onError,
}: TVerticalListingProps) => (
  <article className={classNames.root}>
    {imageSrc && (
      <img
        className={classNames.image}
        src={imageSrc}
        alt={alt || title}
        loading={imageLoading}
        decoding={decoding}
        {...{ onError }}
      />
    )}
    {!imageSrc && (
      <div className={classNames.noImage}>
        <Icon name="image" />
      </div>
    )}
    <div className={classNames.body}>
      <span className={classNames.title}>{title}</span>
      <strong className={classNames.price}>
        {currency && `${currency} `}
        {price}
      </strong>
      {imageOverlayLabel && <span className={classNames.imageOverlayLabel}>{imageOverlayLabel}</span>}
      {location && (
        <span className={classNames.location}>
          <Icon name="location" color="text-placeholder" />
          {location}
        </span>
      )}
    </div>
  </article>
);

export default VerticalListing;
